export const useCurrentUserEmail = () => {
  const user = useCurrentUser();
  return user.value?.email;
};
